/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { faAngleLeft, faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import dayjs from "dayjs";
import { useState } from "react";
import { getFilledArrayOrDefault } from "../../../../utils";
import SingleSelect from "../../../Forms/SingleSelect";
import { Button } from "../../../Helper/Button";
import { useSwitchTabContext } from "../../Layers/fields/useSwitchTab";
import { useRipeningPlanningDateRange } from "../hooks/useRipeningPlanning";
import { RipeningDayPlanning } from "./RipeningDayPlanning";

export default function RipeningClassDistribution() {
    const today = dayjs();
    const isToday = false;
    const { dateRange, next, prev } = useRipeningPlanningDateRange();
    const { ripeningPlanning, layers } = useSwitchTabContext();
    const { ripeningField } = ripeningPlanning;


    // Do not consider allocated state for now, but derive from "dominant_ripening_class_24-10-2023"
    // const getAllocatedLayers = getAllocatedLayersHook();

    // * TODO: Create nice dropdown for this
    const [showPercent, setShowPercent] = useState(false);

    return (
        <div className="mx-n2" >
            <div className="d-flex justify-content-between pt-0 ">
                <div className="d-none">
                    <div className="d-md-flex align-items-center">
                        <Button
                            onClick={prev}
                            className="mx-2"
                            color="primary"
                            icon={faAngleLeft}
                        />
                    </div>
                </div>
                <div className="d-flex flex-nowrap py-5" css={css`overflow-x: auto;`}>
                    {dateRange.map((date, index) => (
                        <div key={index} className="p-0 px-2">
                            <RipeningDayPlanning
                                selected={date.isSame(today, "day")}
                                date={date}
                                // TODO: Discuss with Marco if we need to filter out pallets not in staging on this day
                                // pallets={getAllocatedLayers(date, LAYER_TYPE.PALLET)}
                                pallets={layers.results}
                                ripeningField={ripeningField}
                                showPercent={showPercent}
                                setShowPercent={setShowPercent}
                                hideNumberOfCheckedPallets={true}
                            />
                        </div>
                    ))}
                </div>

                <div className="d-none">
                    <div className={`d-md-flex align-items-center ${(isToday ? "opacity-50" : "")}`}>
                        <Button
                            onClick={next}
                            className="mx-2"
                            disabled={isToday}
                            color="primary"
                            icon={faAngleRight}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
}

export function RipeningFieldSelector() {
    const { ripeningPlanning, activeTab } = useSwitchTabContext();
    const { availableRipeningFields, ripeningField, selectRipeningField } = ripeningPlanning;

    if (!activeTab?.show_class_distribution || getFilledArrayOrDefault(availableRipeningFields).length <= 1) {
        return null;
    }

    return (
        <div className="mb-n3">
            <SingleSelect
                options={availableRipeningFields.map((field) => ({
                    label: field.label,
                    value: field.key,
                }))}
                isClearable={false}
                field="ripening_field"
                post_value={ripeningField?.key || ""}
                setValue={(_, value) => selectRipeningField(value as string)}
            />
        </div>
    );
}
